import type { Button } from '@ibsys/kit';
import type { ComponentProps } from 'react';

type ButtonAppearance = Pick<ComponentProps<typeof Button>, 'color' | 'variant'>;

/**
 * Возвращает красный цвет кнопке удаления без заливки: kit красит её токеном текста поверх
 * красной заливки, а в теме проекта он белый — кнопка пропадает на карточке. Снять, когда тема
 * получит парный контрастный красный, как у `success` и `warning`.
 */
export const DESTRUCTIVE_BUTTON_CLASS = 'text-destructive! border-destructive!';

/** {@link DESTRUCTIVE_BUTTON_CLASS} для кнопки, чей вид задан пропами: сплошной красной белый текст подходит */
export const destructiveButtonClass = ({ color, variant }: ButtonAppearance): string | undefined =>
  color === 'destructive' && (variant === 'outline' || variant === 'ghost') ? DESTRUCTIVE_BUTTON_CLASS : undefined;
